export default __webpack_public_path__ + "static/media/relicarios.a35f6ce3.svg";